export default "__VITE_ASSET__nUxCNtba__"